<template>
  <v-app-bar color="white" elevation="0">
    <v-btn :href="frontendUrl">
      <v-app-bar-title><img :src="inletsLogo" alt="inlets.ai" class="brand-logo-img" /></v-app-bar-title>
    </v-btn>
  </v-app-bar>
  <v-app>
    <v-main>
      <v-container class="fill-height">
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="12" sm="8" md="6">
            <v-card class="pa-4">
              <v-card-title class="text-left">
                <h3>Check your email</h3>
              </v-card-title>
              <v-card-text>
                <p class="mb-4">
                  We sent a confirmation link to your email address. Click the link to confirm your account. We review new accounts and will email you once yours is approved.
                </p>
                <v-alert
                  v-if="resendMessage"
                  :type="resendSuccess ? 'success' : 'error'"
                  variant="tonal"
                  closable
                  class="mb-4"
                >
                  {{ resendMessage }}
                </v-alert>
                <v-text-field
                  v-if="showResend"
                  v-model="email"
                  color="primary"
                  label="Email"
                  variant="outlined"
                  :rules="emailRules"
                  class="mb-2"
                ></v-text-field>
              </v-card-text>
              <v-card-actions class="px-6 pt-0 pb-4">
                <v-btn v-if="showResend" :disabled="!email" @click="resendConfirmation" color="primary">
                  Resend email
                </v-btn>
                <v-btn @click="toLogin" color="primary" variant="outlined">Back to Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "@/axios.js";
import router from "@/router";
import inletsLogo from "@/assets/images/inlets-logo-color.svg";

const BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  name: "ConfirmEmailSent",
  data() {
    return {
      inletsLogo,
      showResend: true,
      email: "",
      resendMessage: null,
      resendSuccess: false,
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Invalid email format",
      ],
    };
  },
  computed: {
    frontendUrl() {
      return process.env.VUE_APP_FRONTEND_URL;
    },
  },
  methods: {
    toLogin() {
      router.push({ name: "Login" });
    },
    async resendConfirmation() {
      this.resendMessage = null;
      try {
        const response = await axios.post(`${BASE_URL}/users/confirmation`, {
          user: { email: this.email },
        });
        this.resendSuccess = true;
        this.resendMessage = response.data?.message || "Confirmation email sent. Please check your inbox.";
      } catch (error) {
        this.resendSuccess = false;
        this.resendMessage =
          error.response?.data?.message || "Something went wrong. Please try again.";
      }
    },
  },
};
</script>
